import CtaMarquee from '../../plugins/gsap/cta-marquee';

const ctas = document.querySelectorAll('.pane--cta');

window.marqueeAnimationScrolltriggers = [];

ctas.forEach((cta) => {
    const ctaAnimation = new CtaMarquee(cta.querySelector('.pane__title'));
    window.marqueeAnimationScrolltriggers.push(ctaAnimation.marquee);
});
